module.exports = __webpack_public_path__ + "static/media/sfr_logo.25e1f316.svg";